(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.directive('azureLogs', ["path", "$q", "widgetSettings", "azureDao", "tablePaginationHelper", "defaultListConverter", "http", "modals", "columnsHelper", "$timeout", function (path, $q, widgetSettings, azureDao, tablePaginationHelper, defaultListConverter, http, modals, columnsHelper, $timeout) {
        return {
            restrict: 'A',
            replace: true,
            templateUrl: path('gui-v2').directive('azure-logs').template(),
            scope: {},
            link: function ($scope, element, attrs) {
                var uuid = 'a54adb3f-8651-4afb-9b51-6aead20ac0de';
                var savedFilters = _(widgetSettings.params(uuid)).mapObject(function (value, key) {
                    return {
                        value: value,
                        loaded: key === 'timespan'
                    };
                });
                $scope.savedFiltersLoaded = false;
                $scope.filters = [
                    {
                        label: 'Subscription',
                        id: 'subscription_id',
                        variants: []
                    },
                    {
                        label: 'Resource group',
                        id: 'resource_group',
                        variants: [],
                        allVariant: { label: 'All resource groups' }
                    },
                    {
                        label: 'Resource',
                        id: 'resource_id',
                        variants: [],
                        allVariant: { label: 'All resources' }
                    },
                    {
                        label: 'Resource Type',
                        id: 'resource_type',
                        variants: [],
                        allVariant: { label: 'All resource types' }
                    },
                    {
                        label: 'Operation',
                        id: 'operations',
                        variants: [],
                        allVariant: { label: 'All operations' }
                    },
                    {
                        label: 'Timespan',
                        id: 'timespan',
                        variants: [
                            {
                                autoId: 'analytics_azure_filter_timespan_dropdown_item_hours_1',
                                id: 'hours 1',
                                label: 'Last 1 hour'
                            },
                            {
                                autoId: 'analytics_azure_filter_timespan_dropdown_item_hours_6',
                                id: 'hours 6',
                                label: 'Last 6 hours'
                            },
                            {
                                autoId: 'analytics_azure_filter_timespan_dropdown_item_hours_24',
                                id: 'hours 24',
                                label: 'Last 24 hours'
                            },
                            {
                                autoId: 'analytics_azure_filter_timespan_dropdown_item_days_7',
                                id: 'days 7',
                                label: 'Last week'
                            },
                            {
                                autoId: 'analytics_azure_filter_timespan_dropdown_item_days_14',
                                id: 'days 14',
                                label: 'Last 2 weeks'
                            },
                            {
                                autoId: 'analytics_azure_filter_timespan_dropdown_item_months_1',
                                id: 'months 1',
                                label: 'Last month'
                            }
                        ],
                        value: savedFilters && savedFilters.timespan && savedFilters.timespan.value || 'days 7'
                    },
                    {
                        label: 'Event category',
                        id: 'categories',
                        variants: [],
                        allVariant: { label: 'All categories' }
                    },
                    {
                        label: 'Event severity',
                        id: 'severities',
                        variants: [],
                        allVariant: { label: 'All severities' }
                    }
                ];
                $scope.applyPossible = false;
                function addAllVariant(filter) {
                    if (filter.allVariant && filter.variants) {
                        filter.variants.unshift(angular.copy(filter.allVariant));
                    }
                }
                function resetVariants(filter) {
                    filter.variants = [];
                    addAllVariant(filter);
                    if (filter.variants.length) {
                        filter.variants.value = filter.value = filter.variants[0].id;
                    }
                }
                $scope.filtersMap = _($scope.filters).chain().map(function (filter) {
                    addAllVariant(filter);
                    return [
                        filter.id,
                        filter
                    ];
                }).object().value();
                function processSavedFilters(filterId) {
                    if ($scope.savedFiltersLoaded) {
                        return;
                    }
                    if (filterId) {
                        if (!savedFilters[filterId] || savedFilters[filterId].loaded) {
                            return;
                        }
                        if (filterId === 'resource_group' && savedFilters.subscription_id && !savedFilters.subscription_id.loaded) {
                            return;
                        }
                        if (filterId === 'resource_id' && savedFilters.resource_group && !savedFilters.resource_group.loaded) {
                            return;
                        }
                        var oldValue = $scope.filtersMap[filterId].value;
                        savedFilters[filterId].loaded = true;
                        if (_(savedFilters[filterId].value).isArray()) {
                            $scope.filtersMap[filterId].value = _(savedFilters[filterId].value).intersection(_($scope.filtersMap[filterId].variants).pluck('id'));
                            if (!$scope.filtersMap[filterId].value.length) {
                                $scope.filtersMap[filterId].value = undefined;
                            }
                        } else {
                            var foundVariant = _($scope.filtersMap[filterId].variants).find(function (variant) {
                                return variant.id === savedFilters[filterId].value;
                            });
                            if (foundVariant) {
                                $scope.filtersMap[filterId].value = foundVariant.id;
                            }
                        }
                        if (oldValue === $scope.filtersMap[filterId].value) {
                            if (filterId === 'subscription_id') {
                                $timeout(function () {
                                    processSavedFilters('resource_group');
                                });
                            }
                            if (filterId === 'resource_group') {
                                $timeout(function () {
                                    processSavedFilters('resource_id');
                                });
                            }
                        }
                    }
                    $scope.savedFiltersLoaded = !_(savedFilters).find(function (filter) {
                        return !filter.loaded;
                    });
                    if ($scope.savedFiltersLoaded) {
                        $timeout(function () {
                            $scope.applyFilters();
                        });
                    }
                }
                processSavedFilters();
                var subscriptionsMap = {};
                azureDao.subscriptions().then(function (response) {
                    $scope.filtersMap.subscription_id.variants = _(response.data && response.data.value).map(function (row) {
                        subscriptionsMap[row.subscriptionId] = row.displayName;
                        return {
                            autoId: 'analytics_azure_filter_subscription_id_dropdown_item_' + row.subscriptionId,
                            id: row.subscriptionId,
                            label: row.displayName
                        };
                    });
                    processSavedFilters('subscription_id');
                    if (!$scope.filtersMap.subscription_id.value && $scope.filtersMap.subscription_id.variants.length) {
                        $scope.filtersMap.subscription_id.value = $scope.filtersMap.subscription_id.variants[0].id;
                        $timeout(function () {
                            $scope.applyFilters();
                        });
                    }
                });
                azureDao.eventCategorySeverity().then(function (response) {
                    $scope.filtersMap.categories.variants = _(response.data && response.data.event_category && response.data.event_category.value).map(function (row) {
                        return {
                            autoId: 'analytics_azure_filter_categories_dropdown_item_' + row.value,
                            id: row.value,
                            label: row.value
                        };
                    });
                    $scope.filtersMap.categories.variants.unshift({
                        autoId: 'analytics_azure_filter_categories_dropdown_item_all',
                        label: 'All categories'
                    });
                    processSavedFilters('categories');
                    $scope.filtersMap.severities.variants = _(response.data && response.data.event_severity && response.data.event_severity.value).map(function (value) {
                        return {
                            autoId: 'analytics_azure_filter_severities_dropdown_item_' + value,
                            id: value,
                            label: value
                        };
                    });
                    $scope.filtersMap.severities.variants.unshift({
                        autoId: 'analytics_azure_filter_severities_dropdown_item_all',
                        label: 'All severities'
                    });
                    processSavedFilters('severities');
                });
                var operationsByResourceType = {};
                var resourceTypeData;
                azureDao.resourceTypes().then(function (response) {
                    resourceTypeData = response.data && response.data.value;
                    setResourceTypeFilter();
                    processSavedFilters('resource_type');
                    $timeout(function () {
                        processSavedFilters('operations');
                    });
                });
                function setResourceTypeFilter() {
                    var filter = $scope.filtersMap.resource_type;
                    if (filter.disabled) {
                        return;
                    }
                    if (!resourceTypeData) {
                        return;
                    }
                    var data = [];
                    operationsByResourceType = {};
                    function processResourceType(rtype) {
                        data.push({
                            id: rtype.name,
                            label: rtype.displayName ? rtype.displayName + ' (' + rtype.name + ')' : rtype.name
                        });
                        operationsByResourceType[rtype.name] = rtype.operations;
                    }
                    _(resourceTypeData).each(function (rtype) {
                        processResourceType(rtype);
                        _(rtype.resourceTypes).each(function (subType) {
                            processResourceType(subType);
                        });
                    });
                    filter.variants = _(data).sortBy('label');
                    addAllVariant(filter);
                }
                function setOperationsFilter() {
                    if (!$scope.filtersMap.resource_type.value) {
                        return;
                    }
                    var filter = $scope.filtersMap.operations;
                    resetVariants(filter);
                    var data = _(operationsByResourceType[$scope.filtersMap.resource_type.value]).map(function (item) {
                        return {
                            id: item.name,
                            label: item.displayName
                        };
                    });
                    filter.variants = _(data).sortBy('label');
                    addAllVariant(filter);
                }
                function setResourceGroupFilter() {
                    var filter = $scope.filtersMap.resource_group;
                    resetVariants(filter);
                    if ($scope.filtersMap.subscription_id.value) {
                        azureDao.resourceGroups({ subscription_id: $scope.filtersMap.subscription_id.value }).then(function (response) {
                            filter.variants = _(response.data && response.data.value).map(function (row) {
                                return {
                                    autoId: 'analytics_azure_filter_resource_group_dropdown_item_' + row.name,
                                    id: row.name,
                                    label: row.name
                                };
                            });
                            addAllVariant(filter);
                            processSavedFilters('resource_group');
                        });
                    } else {
                        processSavedFilters('resource_group');
                    }
                }
                function setResourceFilter() {
                    var filter = $scope.filtersMap.resource_id;
                    resetVariants(filter);
                    if ($scope.filtersMap.subscription_id.value && $scope.filtersMap.resource_group.value) {
                        azureDao.resources({
                            subscription_id: $scope.filtersMap.subscription_id.value,
                            resource_group: $scope.filtersMap.resource_group.value
                        }).then(function (response) {
                            filter.variants = _(response.data && response.data.value).map(function (row) {
                                return {
                                    autoId: 'analytics_azure_filter_resource_id_dropdown_item_' + row.name,
                                    id: row.name,
                                    label: row.name
                                };
                            });
                            addAllVariant(filter);
                            processSavedFilters('resource_id');
                        });
                    } else {
                        processSavedFilters('resource_id');
                    }
                }
                $scope.$watch('filtersMap.resource_group.value', function (newValue) {
                    setResourceFilter();
                    if (newValue) {
                        resetVariants($scope.filtersMap.resource_type);
                        $scope.filtersMap.resource_type.disabled = true;
                        resetVariants($scope.filtersMap.operations);
                        $scope.filtersMap.operations.disabled = true;
                    } else {
                        $scope.filtersMap.resource_type.disabled = false;
                        $scope.filtersMap.operations.disabled = false;
                        setResourceTypeFilter();
                    }
                });
                $scope.$watch('filtersMap.subscription_id.value', function (newValue) {
                    setResourceGroupFilter();
                    if (newValue) {
                        $scope.applyPossible = true;
                    } else {
                        $scope.applyPossible = false;
                    }
                });
                $scope.$watch('filtersMap.resource_type.value', function (newValue) {
                    if (newValue) {
                        $scope.filtersMap.resource_group.disabled = true;
                        $scope.filtersMap.resource_id.disabled = true;
                        setOperationsFilter();
                    } else {
                        resetVariants($scope.filtersMap.operations);
                        $scope.filtersMap.resource_group.disabled = false;
                        $scope.filtersMap.resource_id.disabled = false;
                    }
                });
                function filtersToParams() {
                    var params = {};
                    _($scope.filters).each(function (filter) {
                        if (!filter.value) {
                            return;
                        }
                        if (filter.id === 'timespan') {
                            var endDate = moment();
                            var period = filter.value.split(' ');
                            var startDate = moment(endDate).subtract(period[1], period[0]);
                            params.end_time = endDate.toISOString();
                            params.start_time = startDate.toISOString();
                            return;
                        }
                        if (_(filter.value).isArray()) {
                            params[filter.id] = filter.value.join(',');
                            return;
                        }
                        params[filter.id] = filter.value;
                    });
                    return params;
                }
                $scope.applyFilters = function () {
                    if (!$scope.applyPossible) {
                        return;
                    }
                    if (!$scope.savedFiltersLoaded) {
                        return;
                    }
                    widgetSettings.params(uuid, _($scope.filters).chain().map(function (filter) {
                        if (!filter.value) {
                            return;
                        }
                        return [
                            filter.id,
                            filter.value
                        ];
                    }).compact().object().value());
                    if (!$scope.tableHelper) {
                        initTable();
                    } else {
                        $scope.tableHelper.reload();
                    }
                };
                $scope.options = {
                    columns: [
                        {
                            id: 'id',
                            primary: true,
                            hidden: true
                        },
                        {
                            id: 'level',
                            hidden: true
                        },
                        {
                            id: 'operationName',
                            text: 'Operation Name',
                            converter: 'operationConverter'
                        },
                        {
                            id: '_timeAgo',
                            text: 'Time',
                            converter: 'eventTimeConverter'
                        },
                        {
                            id: 'eventTimestamp',
                            text: 'Time Stamp',
                            format: 'time'
                        },
                        {
                            id: 'subscriptionId',
                            text: 'Subscription',
                            converter: 'subscriptionIdConverter'
                        },
                        {
                            id: 'status.localizedValue',
                            text: 'Status'
                        },
                        {
                            id: 'caller',
                            text: 'Event initiated by'
                        },
                        {
                            id: '_raw',
                            hidden: true
                        }
                    ],
                    options: {
                        checkboxes: false,
                        lineSelection: true,
                        singleSelection: true
                    }
                };
                $scope.tableOptions = {
                    disableTop: true,
                    orderDisplayMode: 'highlight-column',
                    asDivs: true,
                    infinite: true,
                    showWorkingIndicator: true,
                    workingIndicatorDisableGui: false,
                    saveState: false,
                    pagination: {
                        pageSize: 10,
                        ordering: {}
                    },
                    dropdownHeader: true
                };
                function azureFormatConverter(input) {
                    var haveNext = false;
                    if (input.data.nextLink) {
                        $scope.nextLink = input.data.nextLink;
                        haveNext = true;
                    } else {
                        $scope.nextLink = null;
                    }
                    return $q.when({
                        data: {
                            rows: _(input.data.value).map(function (row) {
                                row._raw = angular.copy(row);
                                return row;
                            }),
                            haveNext: haveNext
                        }
                    });
                }
                function initTable() {
                    $scope.initializing = true;
                    $scope.tableHelper = tablePaginationHelper($scope, $scope.tableOptions, $scope.options, function (args) {
                        var query;
                        if (args.offset > 0) {
                            if ($scope.nextLink) {
                                query = azureDao.activityLogs({ next_link: $scope.nextLink }).converter(azureFormatConverter);
                            } else {
                                query = http.local({
                                    data: {
                                        rows: [],
                                        haveNext: false
                                    }
                                });
                            }
                        } else {
                            query = azureDao.activityLogs(filtersToParams()).converter(azureFormatConverter);
                        }
                        return query.converter(defaultListConverter, {
                            columns: $scope.options.columns,
                            converters: {
                                subscriptionIdConverter: function (text) {
                                    return subscriptionsMap[text] || '';
                                },
                                operationConverter: function (text, columnId, columnsMap) {
                                    var result = '';
                                    if (columnsMap.level === 'Informational') {
                                        result = '#' + JSON.stringify({
                                            display: 'text',
                                            'class': 'fa fa-info-circle level-sign level-info',
                                            tooltip: columnsMap.level
                                        });
                                    } else {
                                        result = '#' + JSON.stringify({
                                            display: 'text',
                                            'class': 'fa fa-exclamation-triangle level-sign level-warning',
                                            tooltip: columnsMap.level
                                        });
                                    }
                                    if (!text.value || !text.value.split) {
                                        return result;
                                    }
                                    var arr = text.value.split('/').slice(-2);
                                    if (arr.length === 2 && arr[1] === 'action') {
                                        arr = arr.slice(0, 1);
                                    } else {
                                        arr = _(arr).reverse();
                                    }
                                    return result + _(arr).map(function (word) {
                                        return word.charAt(0).toUpperCase() + word.slice(1);
                                    }).join(' ');
                                },
                                eventTimeConverter: function (text, columnId, columnsMap, args, converters) {
                                    return converters.timeAgo(columnsMap.eventTimestamp);
                                }
                            }
                        }).converter(function (input) {
                            return $q.when(input);
                        });
                    }, function (tableModel) {
                        $scope.initializing = false;
                        $scope.tableModel = tableModel;
                        $scope.totalEvents = $scope.tableHelper.getTotal();
                    });
                }
                $scope.$watchCollection(function () {
                    return $scope.tableHelper ? $scope.tableHelper.getSelectedIds() : [];
                }, function (newValue) {
                    if (newValue && newValue.length === 1) {
                        var data = $scope.tableHelper.getSelected()[0][columnsHelper.getIdxById($scope.options.columns, '_raw')];
                        $scope.tableHelper.clearSelection();
                        modals.alert(data.originalText, {
                            display: 'json',
                            title: 'Event JSON'
                        }, 'lg');
                    }
                });
            }
        };
    }]);
}());